import {
  reasonDefaultOptions,
  reasonOptionsIrreversibleSelected,
  reasonOptionsReversibleSelected,
  IrreversibleIndex,
  ReversibleIndex
} from 'constants/rejectTriggerReason'

export const reasonQualifyOptions = [
  { label: 'Qualifies', value: 1, disabled: false },
  { label: 'Improved site information', value: 2, disabled: true },
  { label: 'KBA criteria revision', value: 3, disabled: true },
  { label: 'Revision to Red List status', value: 4, disabled: true },
  { label: 'Revision of global threshold', value: 5, disabled: true },
  { label: 'No longer geographically restricted', value: 6, disabled: true },
  { label: 'Genuine decline, irreversible', value: 7, disabled: true },
  { label: 'Genuine decline, reversible', value: 8, disabled: true },
  { label: 'Genuine decline, other factors', value: 9, disabled: true }
]

export const reasonNonQualifyOptions = [
  { label: 'Qualifies', value: 1, disabled: true },
  { label: 'Improved site information', value: 2, disabled: false },
  { label: 'KBA criteria revision', value: 3, disabled: false },
  { label: 'Revision to Red List status', value: 4, disabled: false },
  { label: 'Revision of global threshold', value: 5, disabled: false },
  { label: 'No longer geographically restricted', value: 6, disabled: false },
  { label: 'Genuine decline, irreversible', value: 7, disabled: false },
  { label: 'Genuine decline, reversible', value: 8, disabled: false },
  { label: 'Genuine decline, other factors', value: 9, disabled: false }
]

export const mapTriggerReasonFromApi = (reasons = []) => {
  return reasons.map((item) => {
    const value = Number(item)
    return value > 3 ? value - 1 : value
  })
}

export const mapTriggerReasonToApi = (reasons = []) => {
  return reasons.map((item) => (item > 3 ? item + 1 : item))
}

export const hasQualifyingReason = (reasons = []) => {
  if (!Array.isArray(reasons) || reasons.length === 0) return true
  return reasons.some((element) => Number(element) === 1)
}

export const getCheckedReasonOptions = (ids = []) => {
  const qualifyIndex = 0
  const isAnyNonQualifyOptionSelected = ids.some((item) => item.checked && item.value !== 1)

  if (ids[IrreversibleIndex]?.checked) return reasonOptionsIrreversibleSelected
  if (ids[ReversibleIndex]?.checked) return reasonOptionsReversibleSelected
  if (ids[qualifyIndex]?.checked) return reasonQualifyOptions
  if (isAnyNonQualifyOptionSelected) return reasonNonQualifyOptions
  return reasonDefaultOptions
}

export const normalizeCriterionEItems = (items = []) => {
  return items
    .toSorted((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at))
    .map((criterionE) => ({
      ...criterionE,
      trigger_reason_id: criterionE.trigger_reason_id.length === 0 ? [1] : criterionE.trigger_reason_id
    }))
}

export const getCriterionEId = (item = {}) => item.site_irreplaceability_history_id || item.site_irreplaceability_id

export const getYearFromInput = (yearInput) => {
  if (!yearInput) return ''
  if (/^\d{4}$/.test(yearInput)) return yearInput
  const date = new Date(yearInput)
  return Number.isNaN(date.getTime()) ? '' : date.getFullYear().toString()
}

